
var sprite = require("/Users/guten/dev/src/react/antd-mobile/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 48 48\" id=\"check-circle\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <defs/> <g id=\"check-circle_Page-1\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\"> <g id=\"check-circle_step-48px-&#x5BF9;&#x52FE;-&#x5B9E;&#x5FC3;\"> <path d=\"M24,48 C37.254834,48 48,37.254834 48,24 C48,10.745166 37.254834,0 24,0 C10.745166,0 0,10.745166 0,24 C0,37.254834 10.745166,48 24,48 Z M13.1000061,23.2000122 L10.8999939,25.2999878 L20.8999939,35.2000122 L38.1000061,15 L35.8999939,13 L20.6999969,30.7999878 L13.1000061,23.2000122 Z\" id=\"check-circle_Combined-Shape\"/> </g> </g> </symbol>";
module.exports = sprite.add(image, "check-circle");


/*****************
 ** WEBPACK FOOTER
 ** ./components/icon/style/assets/check-circle.svg
 ** module id = 442
 ** module chunks = 0
 **/